import { render, staticRenderFns } from "./ProjectDictItemList.vue?vue&type=template&id=05e413de&scoped=true"
import script from "./ProjectDictItemList.vue?vue&type=script&lang=js"
export * from "./ProjectDictItemList.vue?vue&type=script&lang=js"
import style0 from "./ProjectDictItemList.vue?vue&type=style&index=0&id=05e413de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e413de",
  null
  
)

export default component.exports